import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsuariModel } from '../admin/models/admin.model';
import { map } from 'rxjs/operators'
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

const KEY = 'TUc0emRqRXpkdw==';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private url = environment.urlAPI;
  
  userToken: string;
  codi:string;
  usuari: UsuariModel = new UsuariModel();

  
  constructor(private http: HttpClient,
              private router: Router ) { 
    this.getToken();
  }

  public login(usuari: UsuariModel) {
    const authData = {
      id: usuari.id,
      password: usuari.password,
    };

    // console.log("login " + JSON.stringify(authData));

    return this.http.post (`${this.url}/auth/login`, authData)
    .pipe(
      map( (resp:UsuariModel) => {
        if (resp['id']) {
          // console.log(resp);
          this.usuari = resp;
          this.guardarToken(resp['access_token']);        
        } else {
          throw new Error(resp['message']);
        }
      })
    );
  }

  getCapacitats(usuari:UsuariModel) {
      return this.http.get(`${this.url}/perfils/${usuari.perfil}`)
      .pipe(
        map( (resp:any) => {
          usuari.capacitats = resp.capacitats;
          return usuari;
        })
      );
  }

  logout() {
    this.userToken = '';
    this.codi = '';
    this.usuari = new UsuariModel();
    localStorage.setItem('token','');
    localStorage.setItem('exp','');
    this.router.navigateByUrl('auth/login');
  }

  nouUsuari(usuari: UsuariModel) {
    const authData = {
      // email: usuari.email,
      // password: usuari.password,
      ...usuari,
      returnSecureToken: true
    };

    return this.http.post (
      `${this.url}/register.php`,
      authData
    ).pipe(
      map( resp => {
        this.guardarToken(resp['jwt']);
        return resp;
      })
    );
  }

  private guardarToken( idToken: string) {
    this.userToken = idToken;
    localStorage.setItem('token', idToken);
    // desa l'usuari al storage per recarregar en cas de resfresc de pàgina
    localStorage.setItem('u', CryptoJS.AES.encrypt(JSON.stringify(this.usuari), KEY).toString());
    let hoy = new Date();
    hoy.setSeconds(36000);
    localStorage.setItem('exp', hoy.getTime().toString());

    // if (localStorage.getItem('usuari')) {
    //   this.usuari = JSON.parse(CryptoJS.AES.descrypt(localStorage.getItem('usuari'))) ;
    //   this.recordar = true;
    // }

  }

  getToken() {
    if (localStorage.getItem('token')) {
      this.userToken = localStorage.getItem('token');
      // desa l'usuari al storage per recarregar en cas de resfresc de pàgina
      if (localStorage.getItem('u')) {
        this.usuari = JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('u'),KEY).toString(CryptoJS.enc.Utf8));
      } else {
        this.usuari = new UsuariModel;
      }
    } else {
      this.userToken = '';
      //this.usuari = new UsuariModel;
    }
    return this.userToken;
  }

  estaAutenticat(): boolean {
    
    if ( this.userToken.length < 2) {
      return false;
    }
    const expira = Number(localStorage.getItem('exp'));
    const cuando = new Date();
    cuando.setTime(expira);
    if (cuando > new Date()) {
      return true;
    } else {
      return false;
    }
  }

  perfilAutoritzat(capacitat:string) {
    // console.log(capacitat);
    return this.esAdmin() || capacitat=='gitih' || (this.usuari.capacitats && this.usuari.capacitats.includes(capacitat));
  }

  esAdmin(): boolean {
    //console.log(this.usuari);
    return (this.usuari.perfil==='admin');
  }

  getUsuari() {
    return this.usuari;
  }
}
